import React from 'react';
import styled from 'styled-components';
import { SemanticSIZES } from 'semantic-ui-react';

const Container = styled.div<{ size: string }>`
  width: ${(p) => p.size};
  height: ${(p) => p.size};
  display: grid;

  &.error {
    background-color: #f00;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.8) 0 2px 12px;
    animation: blinkRed 0.5s infinite;
  }

  &.ok {
    background-color: #abff00;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #89ff00 0 2px 12px;
  }

  .warn {
    background-color: #ff0;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #ff0 0 2px 12px;
    animation: blinkYellow 1s infinite;
  }

  @keyframes blinkYellow {
    from {
      background-color: #ff0;
    }
    50% {
      background-color: #aa0;
      box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #ff0 0 2px 0;
    }
    to {
      background-color: #ff0;
    }
  }

  @keyframes blinkRed {
    from {
      background-color: #f00;
    }
    50% {
      background-color: #900;
      box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.8) 0 2px 0;
    }
    to {
      background-color: #f00;
    }
  }
`;

interface LedIndicatorProps {
  severity: 'ok' | 'warn' | 'error';
  size?: SemanticSIZES;
}

export function LedIndicator(props: LedIndicatorProps) {
  let sizePx = '16px';
  switch (props.size) {
    case 'small': {
      sizePx = '12px';
      break;
    }
    case 'large': {
      sizePx = '24px';
      break;
    }
    default: {
      sizePx = '16px';
    }
  }
  return <Container size={sizePx} className={props.severity} />;
}
